export default function SectionHeader({ eyebrow, title, desc, align = "center" }) {
  return (
    <div className={`section-header ${align === "left" ? "left" : ""}`}>
      <p className="section-eyebrow">{eyebrow}</p>
      <h2 className="section-title">{title}</h2>
      {desc ? <p className="section-desc">{desc}</p> : null}
    </div>
  );
}
